import { type Token, isChainflipTokenOrChain } from '@/shared/assets/tokens';
import { useBoostSafeMode } from '@/shared/hooks/useSafeMode';
import useSettingsStore from '@/shared/hooks/useSettingsStore';
import useSwapRequestStore from '@/shared/hooks/useSwapRequestStore';

const isBoostableDeposit = (token: Token | undefined) =>
  isChainflipTokenOrChain(token) && token.chainflipId === 'Btc';

export default function useBoost() {
  const { isBoostDepositInSafeMode } = useBoostSafeMode();
  const srcToken = useSwapRequestStore((state) => state.srcToken);
  const boostEnabled = useSettingsStore((state) => state.boostEnabled);
  const depositBoostable = !isBoostDepositInSafeMode && isBoostableDeposit(srcToken);

  return {
    boostAvailable: depositBoostable,
    boostActive: boostEnabled && depositBoostable,
    isBoostDepositInSafeMode,
  };
}
